import { signOut } from "../../lib/auth-client";

// Routes that require authentication - user will be redirected on logout
export const AUTHENTICATED_ROUTES = [
	"/dashboard",
	"/settings",
	"/business/new",
];

// Check if current path requires authentication
export function isAuthenticatedRoute(pathname: string): boolean {
	// Check exact matches
	if (AUTHENTICATED_ROUTES.includes(pathname)) return true;
	// Check all dashboard sub-routes (e.g. /dashboard/brand/assets)
	if (pathname.startsWith("/dashboard/")) return true;
	return false;
}

export async function signOutAndNavigate(pathname: string) {
	const result = await signOut();

	if (result?.error) {
		throw new Error(result.error.message || "Failed to sign out");
	}

	if (isAuthenticatedRoute(pathname)) {
		window.location.href = "/";
		return;
	}

	window.location.reload();
}

// Dashboard nav items shared between sidebar and bottom nav
export const dashboardNavItems = [
	{
		path: "/dashboard",
		segment: "",
		label: "My Agents",
		icon: "bot" as const,
	},
	{
		path: "/dashboard/founder",
		segment: "founder",
		label: "Founder",
		icon: "user" as const,
	},
	{
		path: "/settings",
		segment: "settings",
		label: "Settings",
		icon: "settings" as const,
	},
] as const;
